<script>
export default {
  data() {
    return {
      theme: 'light',
    }
  },
  mounted() {
    this.setupTheme()
  },
  computed: {
    prefersDarkMode() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
  },
  methods: {
    toggleTheme(theme) {
      this.theme = theme
      document.body.classList.remove('dark-theme', 'light-theme');
      document.body.classList.add(theme + '-theme');
      // data-bs-theme = theme
      document.documentElement.setAttribute('data-bs-theme', theme);
      document.documentElement.style.setProperty('color-scheme', theme);
      localStorage.setItem('theme', theme);
    },
    setupTheme() {
      var currentTheme = localStorage.getItem('theme');
      if (currentTheme) {
        this.theme = currentTheme
      } else if (!currentTheme) {
        this.theme = this.prefersDarkMode ? 'dark' : 'light'
        localStorage.setItem('theme', this.theme);
      }
      document.body.classList.remove('dark-theme', 'light-theme');
      document.body.classList.add(this.theme + '-theme');
      document.documentElement.style.setProperty('color-scheme', this.theme);
    }
  },
  watch: {
    theme(theme) {
      this.toggleTheme(theme)
    }
  }
}
</script>